import { humanize } from 'inflection'
import dayjs from 'v2/utils/dayjs'
import { NodeExecutionDetails } from '../components/node-execution-details'
import { NodeName } from '../components/node-name'
import type { NodeExecutedEvent } from '../types'
import { FlowCompletionHeader } from './header'

export const FlowCompletionAnalysis = ({ node }: { node: NodeExecutedEvent }) => {
  const scheduleStartTime = node.node_config?.schedule_start_time
  const scheduleEndTime = node.node_config?.schedule_end_time
  const valueMap = new Map<string, string | React.ReactNode | undefined>([
    [
      'Previous node',
      <NodeName name={node.previous_node} type={node.previous_node_type} key="previous-node" />,
    ],
    ['Chosen path', humanize(node.chosen_path)],
  ])
  if (scheduleStartTime && scheduleEndTime) {
    valueMap.set(
      'Operating hours',
      <span className="font-jetbrains text-xs-400 tabular-nums">
        {`${dayjs(scheduleStartTime, 'HH:mm').format('h:mm A')} - ${dayjs(scheduleEndTime, 'HH:mm').format('h:mm A')}`}
      </span>,
    )
  }

  return (
    <div className="rounded-lg border border-border bg-card p-3">
      <div className="flex flex-col">
        <FlowCompletionHeader node={node} />
        <div className="flex flex-col gap-4 border-t border-border px-2 py-3">
          {Array.from(valueMap.entries()).map(([key, value]) => (
            <div key={key} className="flex items-start gap-2">
              <div className="font-inter text-s-400 text-secondary w-28 shrink-0">{key}:</div>
              <div className="font-inter text-s-400 text-primary min-w-0 flex-1 whitespace-break-spaces break-words">
                {value || '--'}
              </div>
            </div>
          ))}
        </div>
        <NodeExecutionDetails node={node} />
      </div>
    </div>
  )
}
